import React, { useState } from "react";
import {
    Col, Container, Image, Row,
    Button,
    Modal,
    Form,
} from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import {
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaInstagram,
    FaQuestion,
    FaPhoneAlt,
} from "react-icons/fa";
import axios from "axios";
import { showSuccessMessage } from "../services/utils";

const Footer = () => {
    const BaseURL = process.env.REACT_APP_BASE_URL
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formdetail, setFormdetail] = useState({
        Message: "",
        phone: "",
        type: "phone",

    })

    const contactFormDetails = (e) => {
        const name = e.target.name
        const value = e.target.value
        setFormdetail({
            ...formdetail,
            [name]: value
        })
    }
    const MessageData = (e) => {
        e.preventDefault()
        try {
            axios.post(`${BaseURL}users/userQueries`, formdetail).then(res => showSuccessMessage({ message: "Thanks for reaching us we will get back to you soon" }))

        } catch (error) {
            console.log(error)

        }

        console.log(formdetail)
        setFormdetail({
            Message: "",
            phone: "",

        })
        handleClose()
    }
    return (
        <div>
            <div className="main_footer">
                <div className="ftr_top">
                    <Container>
                        <Row>
                            <Col md={4}>
                                <div className="ftrlogo_div">
                                    <div className="ftr_logo">
                                        <Image src={Logo} fluid />
                                    </div>
                                    <p>
                                        ClinicalEdify is the perfect way to
                                        address the needs of nursing, allied
                                        health, medical, advanced practice, high
                                        school and intern students.
                                    </p>
                                </div>
                            </Col>
                            {/* <Col md={1}></Col> */}
                            {/* <Col md={3}>
                                <div className="ftrothr_div">
                                    <h5>Features</h5>
                                    <ul className="ftr_list">
                                        <li>
                                            <p >Serving Nationwide</p>
                                        </li>
                                        <li>
                                            <p >Streamlined Process</p>
                                        </li>
                                    </ul>
                                </div>
                            </Col> */}
                            <Col md={8}>
                                <Row>
                                    <Col md={6}>
                                        <div className="ftrothr_div mr_abot">
                                            <h5>Useful Links</h5>
                                            <ul className="ftr_list">
                                                <li>
                                                    <a href="/about-us">About Us</a>
                                                </li>
                                                <li>
                                                    <a href="/faq">FAQs</a>
                                                </li>
                                                <li>
                                                    <a href="/contact-us">Contact Us</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="ftrothr_div">
                                            <h5>Social Networks</h5>
                                            <ul className="ftr_list scl_lst">
                                                <li>
                                                    <a disabled className="scl_icn">
                                                        <FaFacebookF />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a disabled className="scl_icn">
                                                        <FaTwitter />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a disabled className="scl_icn">
                                                        <FaLinkedinIn />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a disabled className="scl_icn">
                                                        <FaInstagram />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="ftr_btm ">
                    <Container>
                        <div className="ftrbtm_wrp d-flex justify-content-between align-items-center">
                            <p className="mb-0">
                                Copyright © 2022 ClinicalEdify. All Rights
                                Reserved.
                            </p>
                            <div className="prvcy_terms">
                                <a href="/privacy-policy">Privacy Policy</a>
                                <span> | </span>
                                <a href="/terms-conditions">
                                    Terms & Conditions
                                </a>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>

            <div className="cntct_icn" onClick={handleShow}>
                <FaQuestion />
            </div>

            <Modal show={show} onHide={handleClose} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        Send A Message
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="prfl_flds">
                        <Form onSubmit={MessageData}>
                            <Form.Group controlId="formFile" className="mb-3" >
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter Phone Number"
                                    name="phone"
                                    value={formdetail.phone}
                                    onChange={(e) => { contactFormDetails(e) }}
                                />
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    name="Message"
                                    value={formdetail.Message}
                                    onChange={(e) => { contactFormDetails(e) }}
                                    placeholder="Write your message here"

                                />
                            </Form.Group>

                            <div className="text-center">
                                <Button
                                    className="btn_theme mt-4 w-100"
                                    type="submit"
                                    variant=""
                                >
                                    Submit
                                </Button>
                            </div>
                            <div className="phn_nmbr text-center">
                                <span className="phn_icn">
                                    <FaPhoneAlt />
                                </span>
                                <span>2135629570</span>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Footer;
